/* eslint-disable no-alert */
import React, { Component } from 'react'
import { TextArea, Button, Header, Input, Checkbox, Form } from 'semantic-ui-react'
import firebase from '../../../config/firebase'

export default class ServiceConfiguration extends Component {
  constructor() {
    super()

    this.state = {
      loading: true,
      updating: false,
      hasChange: false,
      service: {
        enable: true,
        description: '',
        title: '',
      },
    }
  }

  componentDidMount() {
    const { region } = this.props

    this.serviceSubscribe = firebase.database().ref(`configs/${region.id}/order_traffic_configs/service`)

    this.serviceSubscribe.on('value', snapshot => {
      const service = snapshot.val() || {}

      this.setState({
        loading: false,
        service,
      })
    })
  }

  componentWillUnmount() {
    if (this.serviceSubscribe) this.serviceSubscribe.off()
  }

  onServiceChange = (field, value) => {
    this.setState(prevState => ({
      service: {
        ...prevState.service,
        [field]: value,
      },
      hasChange: true,
    }))
  }

  onSubmit = async () => {
    const { region } = this.props
    const { service } = this.state

    const confirmation = window.confirm('Are you sure to make a change?')

    if (confirmation) {
      this.setState({ updating: true })

      const updates = {}

      // For older Muuve app version
      if (region.id === 'pnh') {
        updates[`configs/service`] = {
          title: service.title,
          available: service.enable,
          description: service.description,
        }
      }

      updates[`configs/${region.id}/order_traffic_configs/service`] = service

      const err = await firebase.database().ref().update(updates)

      if (err) alert(err)

      this.setState({ updating: false, hasChange: false })
    }

  }

  render() {
    const { region } = this.props
    const { updating, loading, service, hasChange } = this.state

    return (
      <div className="configuration-tab">
        <Header size="large"> {region.name} </Header>
        <Form loading={updating || loading} onSubmit={this.onSubmit}>
          <Form.Field
            control={Checkbox}
            label={`Service is ${service.enable ? 'on' : 'off'}`}
            checked={service.enable}
            toggle
            required
            onChange={() => this.onServiceChange('enable', !service.enable)}
          />
          <Form.Field
            control={Input}
            value={service.title}
            label="Title"
            required
            placeholder="Service title"
            onChange={e => this.onServiceChange('title', e.target.value)}
          />
          <Form.Field
            control={TextArea}
            value={service.description}
            label="Description"
            required
            placeholder="Service description"
            onChange={e => this.onServiceChange('description', e.target.value)}
          />
          <Button type="submit" disabled={!hasChange}>
            Save
          </Button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/configurations/Service/ServiceByRegion.js